import { BarChart3 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { trustMetrics } from "@/data/eventOrganizerContent";

const TrustMetricsSection = () => {
  return (
    <section id="trust-metrics" data-testid="trust-metrics-section" className="py-10">
      <Card data-testid="trust-metrics-card" className="border-fuchsia-200 bg-violet-50/75">
        <CardContent className="space-y-4 p-5 md:p-6">
          <p
            data-testid="trust-metrics-eyebrow-text"
            className="inline-flex items-center gap-2 rounded-full border border-fuchsia-200 bg-fuchsia-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-fuchsia-700"
          >
            <BarChart3 className="h-3.5 w-3.5" />
            Trust Markers
          </p>

          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {trustMetrics.map((metric, index) => (
              <div
                key={metric.label}
                data-testid={`trust-metric-item-${index + 1}`}
                className="rounded-xl border border-fuchsia-200 bg-fuchsia-100/65 p-4"
              >
                <p data-testid={`trust-metric-value-${index + 1}`} className="text-2xl font-semibold text-violet-950">
                  {metric.value}
                </p>
                <p
                  data-testid={`trust-metric-label-${index + 1}`}
                  className="mt-1 text-xs font-semibold uppercase tracking-[0.12em] text-fuchsia-700"
                >
                  {metric.label}
                </p>
                <p data-testid={`trust-metric-context-${index + 1}`} className="mt-1 text-xs text-violet-800/80">
                  {metric.context}
                </p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default TrustMetricsSection;